import { render, staticRenderFns } from "./Professionalization.vue?vue&type=template&id=6343856c&scoped=true&"
import script from "./Professionalization.vue?vue&type=script&lang=js&"
export * from "./Professionalization.vue?vue&type=script&lang=js&"
import style0 from "./Professionalization.vue?vue&type=style&index=0&id=6343856c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6343856c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
